import { ITokenStorage } from '../interfaces/token-storage.interface';
import { Session } from '../../domain/entities/session.entity';
import { User } from '../../domain/entities/user.entity';

export class GetCurrentSessionUseCase {
  constructor(private readonly tokenStorage: ITokenStorage) {}

  public execute(): Session | null {
    const token = this.tokenStorage.getToken();
    const storedUser = this.tokenStorage.getUser();

    if (!token || !storedUser) {
      return null;
    }

    try {
      // Validar si el JWT ha expirado por tiempo antes de considerar la sesión válida
      const parts = token.split('.');
      if (parts.length === 3 && parts[1]) {
        const payloadStr = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
        const payload = JSON.parse(payloadStr);
        if (payload.exp && typeof payload.exp === 'number' && payload.exp * 1000 < Date.now()) {
          this.tokenStorage.clear();
          return null;
        }
      }

      const user = User.create(storedUser);
      return new Session({ user, token });
    } catch {
      this.tokenStorage.clear();
      return null;
    }
  }
}
